<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import httpClient from '@/utils/httpClient' 


export default {
  mounted() {
    httpClient.get('/logout',null).then(
      () => 
      {
        this.logout()
        window.top.location.href = process.env.VUE_APP_HOME_PAGE;
      }
    ).catch((err)=> console.log(err));

    // this.$router.push('/login');
    // console.log(process.env.VUE_APP_HOME_PAGE)
  },
  methods: {
    async logout() {
      // await this.$store.dispatch('logout');
      this.removeGuestData();
    },
    ...mapActions({
      removeGuestData: 'guests/removeData'
    }),
    
  },
  computed: {
    ...mapState('guests', {
      guestEmail: state => state.email
    })
  },
  }
</script>